/**
 * @generated SignedSource<<f0847987123727f55fd59182b7daa3a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type customPageElementViewRendererFragment$data = {
  readonly __typename: "HelpLayoutBreadcrumbElement";
  readonly " $fragmentSpreads": FragmentRefs<"breadcrumbsElementFragment">;
  readonly " $fragmentType": "customPageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutEditorElement";
  readonly " $fragmentSpreads": FragmentRefs<"editorViewRendererFragment">;
  readonly " $fragmentType": "customPageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutHeroElement";
  readonly " $fragmentSpreads": FragmentRefs<"heroElementFragment">;
  readonly " $fragmentType": "customPageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutNoContentElement";
  readonly __typename: "HelpLayoutNoContentElement";
  readonly " $fragmentType": "customPageElementViewRendererFragment";
} | {
  readonly __typename: "QueryError";
  readonly extensions: ReadonlyArray<{
    readonly statusCode: number | null;
  }> | null;
  readonly identifier: string | null;
  readonly message: string | null;
  readonly " $fragmentType": "customPageElementViewRendererFragment";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "customPageElementViewRendererFragment";
};
export type customPageElementViewRendererFragment$key = {
  readonly " $data"?: customPageElementViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"customPageElementViewRendererFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "customPageElementViewRendererFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "editorViewRendererFragment"
        }
      ],
      "type": "HelpLayoutEditorElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "heroElementFragment"
        }
      ],
      "type": "HelpLayoutHeroElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "breadcrumbsElementFragment"
        }
      ],
      "type": "HelpLayoutBreadcrumbElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "identifier"
        },
        {
          "kind": "ScalarField",
          "name": "message"
        },
        {
          "kind": "LinkedField",
          "name": "extensions",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "statusCode"
            }
          ]
        }
      ],
      "type": "QueryError"
    }
  ],
  "type": "HelpLayoutElement",
  "abstractKey": "__isHelpLayoutElement"
};

(node as any).hash = "156219b63b3d814fbeae17e6b0d0ced5";

export default node;
